import { getConfig } from '@/utils/runtimeConfig';

export const redirectToSSOAuthentication = async (
  subId: string,
  projectId?: string
) => {
  const config = await getConfig();

  const url = new URL(
    `${config.monoDomainUrl}/saml-auth/authenticate`
  );
  url.searchParams.append('subId', subId);

  if (projectId) {
    url.searchParams.append('projectId', projectId);
  }

  window.location.replace(url);
};
